import { isArray, join } from 'lodash-es';
import { clickPhantomAnchor } from './links.utils';

export type FileRowType = Array<string | number | boolean | undefined>;

export function downloadAsFile({
	data,
	mimetype,
	filename = 'data.txt',
	colDelimeter = ',',
	rowDelimeter = '\n',
}: {
	data: Array<FileRowType>;
	mimetype: string;
	filename?: string;
	colDelimeter?: string;
	rowDelimeter?: string;
}) {
	let content = `data:${mimetype};charset=utf-8,`;

	const rows: string = isArray(data)
		? data.map((row: FileRowType) => (isArray(row)
			? join(row.map(value => `"${value}"`.replace(/#/g, '')), colDelimeter)
			: String(row))).join(rowDelimeter)
		: String(data);

	content += `${rows}${rowDelimeter}`;

	clickPhantomAnchor({
		url: content,
		download: filename,
	});
}

export const getBase64Async = async (file: File | Blob): Promise<string> =>
	new Promise<string>((resolve, reject) => {
		const reader = new FileReader();
		reader.readAsDataURL(file);

		reader.onload = function () {
			resolve(reader.result as string);
		};

		reader.onerror = reject;
	});

export const getCSVContentFromObjects = (data: Array<Record<string, string>>, headers: string[]): string[][] => {
	const content = data.map((row) => headers.map((header) => row[header]));

	return [
		// first row is headers
		headers,
		// latest rows are content
		...content,
	];
};
